import React from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Form from 'form/Form';
import Typography from '@material-ui/core/Typography';
import SendMessageFormFields from './SendMessageFormFields';

const SendMessageDialog = ({ open, onSubmit, onCancel, tenantActor, ownerActor, predefinedTexts }) => {
    const initialValues = {
        senderActorId: '' + ownerActor.id,
        sendAsAdmin: false,
        body: predefinedTexts.find(o => o.key === 'DefaultFooter')?.text ?? ''
    };

    return (
        <Dialog fullWidth open={open} onClose={onCancel}>
            <Form
                initialValues={initialValues}
                onSubmit={onSubmit}
            >
                {({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <DialogTitle disableTypography>
                            <Typography variant="h5">
                                Send message
                            </Typography>
                        </DialogTitle>
                        <DialogContent>
                            <SendMessageFormFields
                                tenantActor={tenantActor}
                                ownerActor={ownerActor}
                                predefinedTexts={predefinedTexts}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button
                                type="submit"
                                variant="outlined"
                                color="primary"
                            >
                                Send
                            </Button>
                            <Button
                                type="button"
                                variant="outlined"
                                color="primary"
                                onClick={onCancel}
                            >
                                Close
                            </Button>
                        </DialogActions>
                    </form>
                )}
            </Form>
        </Dialog>
    );
};

SendMessageDialog.propTypes = {
    open: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    tenantActor: PropTypes.object.isRequired,
    ownerActor: PropTypes.object.isRequired,
    predefinedTexts: PropTypes.array.isRequired,
};

export default SendMessageDialog;
